import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=0defa4f6&scoped=true&"
import script from "./Site.vue?vue&type=script&lang=ts&"
export * from "./Site.vue?vue&type=script&lang=ts&"
import style0 from "./Site.vue?vue&type=style&index=0&id=0defa4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0defa4f6",
  null
  
)

export default component.exports